import { render, staticRenderFns } from "./GitBranch.vue?vue&type=template&id=16925e1d&"
import script from "./GitBranch.vue?vue&type=script&lang=js&"
export * from "./GitBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports